import script from "./PriceLists.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceLists.vue?vue&type=script&setup=true&lang=js"

import "./PriceLists.vue?vue&type=style&index=0&id=65b54776&lang=css"

const __exports__ = script;

export default __exports__